<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            :pressed="activationFilter === 'active'"
            variant="outline-success"
            @click="updateActivationFilter('active')"
        >
            Actifs
        </b-button>
        <b-button
            :pressed="activationFilter === 'old'"
            variant="outline-warning"
            @click="updateActivationFilter('old')"
        >
            Anciens
        </b-button>
        <b-button
            :pressed="activationFilter === 'all'"
            variant="outline-secondary"
            @click="updateActivationFilter('all')"
        >
            Tous
        </b-button>
    </b-button-group>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'ClientActivationFilter',

    mixins: [DataUpdater],

    methods: {
        updateActivationFilter(value) {
            this.$store.commit('browsing/SET_CLIENT_ACTIVATION_FILTER', value)
            this.$emit('activation-filter-has-changed')
            // this.$root.$refs.clientsTable.filterItems()
        },
    },

    computed: {
        ...mapState({
            activationFilter: (state) => state.browsing.clientsActivationFilter,
            activePage: (state) => state.browsing.pageName,
        }),
    },
}
</script>

<style scoped></style>
